import React, { Fragment, useState } from "react";
import { Modal } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import FormInput from "../../form-input/form-input.component";
import { connect } from "react-redux";
import CKEditor from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { addType } from "../../../actions/Types.action";
import "../bootstrap.css";
import { setAlert } from "../../../actions/alert";

const AddType = ({ addType, setAlert , subCategoryId }) => {
  const [addModals, setShow] = useState(false);
  const [adv, setAdv] = useState({
    title: "",
    description: "",
    url :"",
    sortBy:"",
    subCategory :subCategoryId
  });

  const handleShow = () => setShow(true);
  const handleClose = () => setShow(false);

  const { title, description , url , subCategory ,sortBy} = adv;



  const onChange = (e) => {
    setAdv({ ...adv, [e.target.name]: e.target.value });
  };
  const onSubmit = async (e) => {
    e.preventDefault();
    if (title === ""  ) {
      setAlert("ارجو تعبئة كل الحقول و تحميل الصور لهدا الصنف", "danger");
    } else {
      addType(title, description ,url , subCategory,sortBy);
      setAdv({
        title: "",
        description: "",
        url:"",
        sortBy: "",
        subCategory : subCategoryId
      });
      setAlert("تمت إضافة الصنف  بنجاح", "success");
      setShow(false);
    }
  };

  return (
    <Fragment>
      <a
        onClick={handleShow}
      >
        {" "}
        <FontAwesomeIcon icon={faPlus} />{" "}
      </a>
      <Modal show={addModals} onHide={handleClose}>
        <Modal.Header>
          <Modal.Title> إضافة صنف  للقسم فرعي </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form onSubmit={onSubmit}>            
            <FormInput
              name="title"
              type="text"
              handleChange={onChange}
              value={title}
              label="عنوان الصنف"
              required
            />
             <FormInput
              name="sortBy"
              type="number"
              handleChange={onChange}
              value={sortBy}
              label="الترتيب"
              required
            />
             <FormInput
              name="url"
              type="text"
              handleChange={onChange}
              value={url}
              label="رمز الصنف المضاف للقسم الفرعي"
              required
            />
           

            <label htmlFor="firstName" className="active">
              عن 
            </label>
            <CKEditor
              editor={ClassicEditor}
              data={description}
              onChange={(event, editor) => {
                const data = editor.getData();
                setAdv({ ...adv, description: data });
              }}
            />
          </form>
        </Modal.Body>
        <Modal.Footer>
          <button
            className="btn btn-dark btn-block"
            type="submit"
            onClick={onSubmit}
          >
            {" "}
            إضافة{" "}
          </button>
        </Modal.Footer>
      </Modal>
    </Fragment>
  );
};

export default connect(null, {
  addType,
  setAlert,
})(AddType);
